// Swiper 6 → 14（Issue #141）。
//
// 6 の "swiper/swiper-bundle.min" は 14 の exports に存在しない。
// 全モジュール入りは "swiper/bundle" / "swiper/css/bundle" に変わった。
//
// **セレクタのクラス名も swiper-container → swiper に変わっている。**
// ただし変えてよいのは、この pack（frontpage）が動かす公開ページだけ。
// ダッシュボードの注文フォームは Sprockets の vendored Swiper 4.5.0
// （app/assets/javascripts/assan/swiper/）が動かしており、
// そちらは swiper-container のままでないと壊れる。
import Swiper from "swiper/bundle"
import "swiper/css/bundle"

const customerVoiceSwiper = () => {
  new Swiper("#customer-voice.swiper", {
    loop: true,
    slidesPerView: 1.5,
    spaceBetween: 30,
    loop: true,
    centeredSlides: true,
  })
}

const touchExampleSwiper = () => {
  new Swiper("#touch-example--pc.swiper", {
    loop: true,
    autoPlay: true,
    centeredSlides: true,
    slidesPerView: 3.8,
  })
}

const spTouchExampleSwiper = () => {
  new Swiper("#touch-example--sp.swiper", {
    loop: true,
    autoPlay: true,
    centeredSlides: true,
    slidesPerView: 1.8,
  })
}

const spCartoonExampleSwiper = () => {
  new Swiper("#cartoon-example--sp.swiper", {
    loop: true,
    autoPlay: true,
    centeredSlides: true,
    slidesPerView: 1.8,
  })
}

const preOrderSwiper = () => {
  return new Swiper("#pre-order.swiper", {
    loop: false,
    autoHeight: true,
    allowTouchMove: false,
    on: {
      transitionEnd: function () {
        $("html,body").animate({
          scrollTop: $("body").offset().top,
        })
      },
    },
  })
}

const partnersSwiper = () => {
  new Swiper("#partners.swiper", {
    loop: true,
    autoPlay: true,
    centeredSlides: true,
    slidesPerView: 1.8,
  })
}

export {
  customerVoiceSwiper,
  touchExampleSwiper,
  spTouchExampleSwiper,
  spCartoonExampleSwiper,
  preOrderSwiper,
  partnersSwiper,
}
